import { render, staticRenderFns } from "./GetTitle.vue?vue&type=template&id=3dcffe62&scoped=true&"
import script from "./GetTitle.vue?vue&type=script&lang=js&"
export * from "./GetTitle.vue?vue&type=script&lang=js&"
import style0 from "./GetTitle.vue?vue&type=style&index=0&id=3dcffe62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcffe62",
  null
  
)

export default component.exports